import { render, staticRenderFns } from "./SalesItem.vue?vue&type=template&id=f1d2c920&"
import script from "./SalesItem.vue?vue&type=script&lang=js&"
export * from "./SalesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports